import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../../api/store";
import { DueDatesInfo, PolicyCoveragePremiumDetailsState } from "./policy-coverage-premium-details.state";

export type policyCoveragePremiumDetailsType = 
    null 
    | "amountOfInsurance" 
    | "coveragePeriod" 
    | "dueDates" 
    | "refundOfPremiums" 
    | "terminationAge" 
    | "dueDatesInfo";
export type PolicyCoveragePremiumDetailsField = 
    "amountOfInsurance" 
    | "coveragePeriod" 
    | "dueDates" 
    | "refundOfPremiums" 
    | "terminationAge"
    | "dueDatesInfo";
export type PolicyCKEditorCoveragePremiumDetailsType = 
    'amountOfInsurance' 
    | 'coveragePeriod' 
    | 'refundOfPremiums'

const initialState: PolicyCoveragePremiumDetailsState = {
    policyCoveragePremiumDetailsType: null,
    amountOfInsurance: "",
    coveragePeriod: "",
    dueDates: "",
    refundOfPremiums: "",
    terminationAge: null,
    dueDatesInfo: {
        additions_due_date: '',
        first_due_date: '',
        renewal_due_date: '',
    }
};

const policyCoveragePremiumDetailsSlice = createSlice({
    name: "policyCoveragePremiumDetailsSlice",
    initialState,
    reducers: {
        setPolicyCoveragePremiumDetailsType: ( state, action: PayloadAction<policyCoveragePremiumDetailsType> ) => {
            state.policyCoveragePremiumDetailsType = action.payload;
        },
        onChangePolicyCoveragePremiumDetails: ( state, action: PayloadAction<{ field: PolicyCoveragePremiumDetailsField; value: string | number | null | DueDatesInfo; }> ) => {
            const { field, value } = action.payload;

            if (field === "terminationAge") {
                state.terminationAge = typeof value === "number" ? value : null;
                return;
            }

            if (field === "dueDatesInfo") {
                if (
                    typeof value === "object" &&
                    value !== null &&
                    "additions_due_date" in value &&
                    "first_due_date" in value &&
                    "renewal_due_date" in value
                ) {
                    state.dueDatesInfo = value;
                }
                return;
            }

            if (typeof value === "string") {
                state[field] = value;
            }
        },
        resetPolicyCoveragePremiumDetails: () => initialState,
    },
});

export const {
    setPolicyCoveragePremiumDetailsType,
    onChangePolicyCoveragePremiumDetails,
    resetPolicyCoveragePremiumDetails,
} = policyCoveragePremiumDetailsSlice.actions;

export const selectPolicyCPDType = (state: RootState) => state.policyCoveragePremiumDetailsSlice.policyCoveragePremiumDetailsType;
export const selectPolicyAmountInsurance = (state: RootState) => state.policyCoveragePremiumDetailsSlice.amountOfInsurance;
export const selectPolicyCoveragePeriod = (state: RootState) => state.policyCoveragePremiumDetailsSlice.coveragePeriod;
export const selectPolicyDueDates = (state: RootState) => state.policyCoveragePremiumDetailsSlice.dueDates;
export const selectPolicyDueDatesInfo = (state: RootState) => state.policyCoveragePremiumDetailsSlice.dueDatesInfo;
export const selectPolicyRefundOfPremiums = (state: RootState) => state.policyCoveragePremiumDetailsSlice.refundOfPremiums;
export const selectPolicyTerminationsAge = (state: RootState) => state.policyCoveragePremiumDetailsSlice.terminationAge;

export default policyCoveragePremiumDetailsSlice.reducer;